import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that wraps the "ficha técnica" specs table.
 * Listens for variant update events and morphs the table so that
 * variant-sourced metafield rows stay in sync with the selected variant.
 */
class PivotFichaTecnica extends HTMLElement {
  connectedCallback() {
    // The specs table lives in its own section (pivot-ficha-descripcion), separate from the
    // section that hosts the variant-picker, so `variant:update` won't bubble up to a shared
    // `.shopify-section` ancestor. Listen on `document` instead, as documented in @theme/events.
    document.addEventListener(ThemeEvents.variantUpdate, this.updateTable);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateTable);
  }

  /**
   * Updates the specs table.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  updateTable = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newTable = event.detail.data.html.querySelector(
      `pivot-ficha-tecnica[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newTable) return;

    morph(this, newTable, { childrenOnly: true });
  };
}

if (!customElements.get('pivot-ficha-tecnica')) {
  customElements.define('pivot-ficha-tecnica', PivotFichaTecnica);
}
